module.exports = __webpack_public_path__ + "static/media/play-egg-boss.4460fe6d.png";